vPosition = transformed.xzy;
